module.exports = __webpack_public_path__ + "static/media/Benifits2.e749a593.webp";